import 'antd/dist/antd.css';
import React, { useEffect, useState } from 'react';
import { getTextUsage } from '../../../redux/services/text';
import {
  getTextSentThisMonth,
  getContactsHelpedByOrg,
} from '../../../features/texting-hub/api';

// Shown as "SMS segments/MMS messages", e.g. 20/2. 'N/A' until loaded, or
// when Andromeda does not send the breakdown yet.
const formatSplit = direction =>
  direction ? `${direction.smsSegments}/${direction.mmsMessages}` : 'N/A';

export default function TextUsage({ orgId }) {
  const [CreateAndSendTotal, setCreateAndSendTotal] = useState('N/A');
  const [ContactsHelped, setContactsHelped] = useState('N/A');
  const [breakdown, setBreakdown] = useState(null);
  const [CSerror, setCSError] = useState(null);
  const [THerror, setTHError] = useState(null);

  useEffect(() => {
    fetchMonthlyTextUsage();
    fetchTHubUsage();
  }, [orgId]);

  const fetchMonthlyTextUsage = async () => {
    const usage = await getTextUsage(orgId);

    if (usage === 'N/A') {
      setCSError('Error loading Create & Send metrics');
    } else setCreateAndSendTotal(usage);
  };

  const fetchTHubUsage = async () => {
    try {
      const { breakdown } = await getTextSentThisMonth();
      const contactsHelped = await getContactsHelpedByOrg();
      setBreakdown(breakdown || null);
      setContactsHelped(contactsHelped);
    } catch (err) {
      setBreakdown(null);
      console.error('[fetchTHubUsage]', err);
      setTHError('Error loading Texting Hub metrics');
    }
  };

  return (
    <>
      <h3>
        <u>
          <b>Texting Stats:</b>
        </u>
      </h3>
      <p>
        Create & Send Texts (Past 30 Days): <b>{CreateAndSendTotal}</b>
      </p>
      <p>
        Texting Hub Sent Texts SMS/MMS (Past 30 Days):{' '}
        <b>{formatSplit(breakdown?.outbound)}</b>
      </p>
      <p>
        Texting Hub Received Texts SMS/MMS (Past 30 Days):{' '}
        <b>{formatSplit(breakdown?.inbound)}</b>
      </p>
      <p>
        Contacts Helped (All-Time): <b>{ContactsHelped}</b>
      </p>
      {CSerror && (
        <p style={{ color: 'red', fontSize: '11px', marginTop: '4px' }}>
          {CSerror}
        </p>
      )}
      {THerror && (
        <p style={{ color: 'red', fontSize: '11px', marginTop: '4px' }}>
          {THerror}
        </p>
      )}
    </>
  );
}
